// AQUI PONEMOS LA CONFIGURACION INICIAL DE RECETA FORMULARIO, ESTO ES PARA QUE SEA MAS MANEJABLE EL CODIGO

export const initialConfig = {
    // configuracion inicial de la receta por segmentos
      //margenes totales iniciales
      margenSuperior: 1,
      margenInferior: 1,
      margenIzquierdo: 1,
      margenDerecho: 1,
      alineacion: "izquierda",
      tamañoHoja: "Media Carta", 
      anchoPersonalizado: 21.59, 
      altoPersonalizado: 14,
      zoom: 0.5, 
      // Imagen Principal
      mostrarImagen: true,
      margenXImagen: 0,
      margenYImagen: 0,
      anchoImagen: 2.6, 
      altoImagen: 3,
      //Nombre Clinica
      mostrarNombreClinica: false, 
          
      //Nombre médico
      mostrarNombre: true,
      margenXNombre: 6.4,  
      margenYNombre: -4.1, 
      tamañoLetraNombre: 22,
      colorNombre: "#2a9d8f",       
      boldNombre: true, 
      fuenteNombre: "Arial",   
      //Escuela
      mostrarEscuela: true,
      margenXEscuela: 8,
      margenYEscuela: -4.6,
      tamañoLetraEscuela: 16,
      fuenteEscuela: "Arial",
      colorEscuela: "#000000", // Color negro mostrado en la imagen
      boldEscuela: false,
      //Comentarios
      mostrarComentarios: false,
      //Titulo univ
      mostrarTituloUniversitario: true,
      margenXTituloUniversitario: 7.1,
      margenYTituloUniversitario: -4.9,
      tamañoLetraTituloUniversitario: 12,
      fuenteTituloUniversitario: "Arial",
      colorTituloUniversitario: "#000000", // Color negro
      boldTituloUniversitario: false,
      //Cédula prof
      mostrarCedulas: true,
      margenXCedulas: 11.3,
      margenYCedulas: -5.85,
      tamañoLetraCedulas: 12,  // Añadir valor predeterminado si no se muestra en la imagen
      fuenteCedulas: "Arial",
      colorCedulas: "#000000", // Color negro
      boldCedulas: false,
      //Especialidad
      mostrarEspecialidad: true,
      margenXEspecialidad:  7.1,
      margenYEspecialidad: -6.2,
      tamañoLetraEspecialidad: 12,
      fuenteEspecialidad: "Arial",
      colorEspecialidad: "#000000", // Color negro
      boldEspecialidad: false,
      //Cédula especialidad
      mostrarCedulaEspecialidad: true,
      margenXCedulaEspecialidad: 11.35,
      margenYCedulaEspecialidad: -7.1,
      tamañoLetraCedulaEspecialidad: 12, // Asumiendo el valor predeterminado
      fuenteCedulaEspecialidad: "Arial",
      colorCedulaEspecialidad: "#000000", // Color negro
      boldCedulaEspecialidad: false,
      //Direccion
      mostrarDireccion: true,
      margenXDireccion: 0,
      margenYDireccion: 2.4,
      tamañoLetraDireccion: 12,
      fuenteDireccion: "Arial",
      colorDireccion: "#000000",
      boldDireccion: true,
      //Cel
      mostrarTelefonoCelular: true,
      margenXCelular: 0,
      margenYCelular: 2.1,
      tamañoLetraCelular: 12,
      fuenteCelular: "Arial",
      colorCelular: "#000000",
      boldCelular: true,
      //Linea Sup
      mostrarLineaSuperior: true,
      margenXLineaSuperior: 0,
      margenYLineaSuperior: -8.9,
      grosorLineaSuperior: 2,
      colorLineaSuperior: "#5AC0B1", // Código de color actualizado
      longitudLineaSuperior: 21.5,
      //Marca de agua
      mostrarMarcaAgua: true,
      margenXMarcaAgua: 7,
      margenYMarcaAgua: -0.4,
      anchoMarcaAgua: 7.9,
      altoMarcaAgua: 7.7,
      //Fecha
      mostrarFecha: true,
      margenXFecha: 18.2,
      margenYFecha: 0.15,
      tamañoLetraFecha: 11,
      fuenteFecha: "Arial",
      colorFecha: "#000000",
      boldFecha: false,
      //Nombre Paciente
      mostrarNombrePaciente: true,
      margenXNombrePaciente: 0,
      margenYNombrePaciente: -10.7,
      tamañoLetraNombrePaciente: 12,
      fuenteNombrePaciente: "Arial",
      colorNombrePaciente: "#000000",
      boldNombrePaciente: false,
      //Diagnostico
      mostrarDiagnostico: true,
      margenXDiagnostico: 0,
      margenYDiagnostico: -10.7,
      tamañoLetraDiagnostico: 12,
      fuenteDiagnostico: "Arial",
      colorDiagnostico: "#000000",
      boldDiagnostico: false,
      //Tratamiento
      mostrarTratamiento: true,
      margenXTratamiento: 0,
      margenYTratamiento: -10.7,
      tamañoLetraTratamiento: 12,
      fuenteTratamiento: "Arial",
      colorTratamiento: "#000000",
      boldTratamiento: false,
      //Linea inf
      mostrarLineaInferior: true,
      margenXLineaInferior: 0,
      margenYLineaInferior: 0.1,
      grosorLineaInferior: 2,
      colorLineaInferior: "#5AC0B1",  // Código de color según la imagen
      longitudLineaInferior: 21.5, 
      tipoLineaInferior: "solid",    
      //Firma 
      margenXFirma: 17.2,
      margenYFirma: 1,
      tamañoLetraFirma: 12, 
      colorFirma: "#000000",
      boldFirma: false,
      fuenteFirma: "Arial",
      mostrarFirma: true,  

      urlImagenPersonalizada: "", // Imagen encabezado y marca de agua
      urlFirmaPersonalizada: "", // Imagen firma

      // === NUEVOS CAMPOS PARA EDAD Y SIGNOS VITALES ===
      //EDAD
      mostrarEdad: true, 
      margenXEdad: 17,
      margenYEdad: 1,
      tamañoLetraEdad: 12,
      fuenteEdad: "Arial",
      colorEdad: "#000000",
      boldEdad: false,
       // FECHA DE NACIMIENTO
      mostrarFechaNacimiento: false,
      margenXFechaNacimiento: 0,
      margenYFechaNacimiento: 0,
      tamañoLetraFechaNacimiento: 12,
      fuenteFechaNacimiento: "Arial",
      colorFechaNacimiento: "#000000",
      boldFechaNacimiento: false,
      // SIGNOS
      mostrarSignos: false, 
      margenXSignos: 1,
      margenYSignos: 2,
      tamañoLetraSignos: 12,
      fuenteSignos: "Arial",
      colorSignos: "#000000",
      boldSignos: false,
      mostrarTA: true,
      mostrarFC: true,
      mostrarFR: true,
      mostrarTemp: true,
      mostrarSpO2: true,
      mostrarPeso: true,
      mostrarTalla: true,
      mostrarIMC: true,
      mostrarClasificacionIMC: true,

      // Distribución de signos vitales
      // "prosa" conserva el comportamiento actual con comas
      // "individual" permite mover cada signo por separado
      modoDistribucionSignos: "prosa",

      // Posiciones individuales RELATIVAS al bloque general de signos
      // Defaults en vertical para evitar que se encimen al activar este modo

      margenXTASignos: 0,
      margenYTASignos: 0,

      margenXFCSignos: 0,
      margenYFCSignos: 0.5,

      margenXFRSignos: 0,
      margenYFRSignos: 1,

      margenXTempSignos: 0,
      margenYTempSignos: 1.5,

      margenXSpO2Signos: 0,
      margenYSpO2Signos: 2,

      margenXPesoSignos: 0,
      margenYPesoSignos: 2.5,

      margenXTallaSignos: 0,
      margenYTallaSignos: 3,

      margenXIMCSignos: 0,
      margenYIMCSignos: 3.5,

      margenXClasificacionIMCSignos: 0,
      margenYClasificacionIMCSignos: 4,

      //etiquetas solamente
      mostrarEtiquetaCedulas: true,
      mostrarEtiquetaCedulaEspecialidad: true,
      mostrarEtiquetaCelular: true,
      mostrarEtiquetaFecha: true,
      mostrarEtiquetaNombrePaciente: true,
      mostrarEtiquetaDiagnostico: true,
      mostrarEtiquetaTratamiento: true,
      mostrarEtiquetaEdad: true,
      mostrarEtiquetaFechaNacimiento: true,
      mostrarEtiquetaSignos: true,
      mostrarEtiquetasInternasSignos: true,   // "TA", "FC", "Temp", "Peso", etc.

      // Textos libres personalizados
      textosLibres: [],
       };

       export const signosConfigurables = [
  {
    label: "TA",
    visibleKey: "mostrarTA",
    xKey: "margenXTASignos",
    yKey: "margenYTASignos",
  },
  {
    label: "FC",
    visibleKey: "mostrarFC",
    xKey: "margenXFCSignos",
    yKey: "margenYFCSignos",
  },
  {
    label: "FR",
    visibleKey: "mostrarFR",
    xKey: "margenXFRSignos",
    yKey: "margenYFRSignos",
  },
  {
    label: "Temp",
    visibleKey: "mostrarTemp",
    xKey: "margenXTempSignos",
    yKey: "margenYTempSignos",
  },
  {
    label: "SpO₂",
    visibleKey: "mostrarSpO2",
    xKey: "margenXSpO2Signos",
    yKey: "margenYSpO2Signos",
  },
  {
    label: "Peso",
    visibleKey: "mostrarPeso",
    xKey: "margenXPesoSignos",
    yKey: "margenYPesoSignos",
  },
  {
    label: "Talla",
    visibleKey: "mostrarTalla",
    xKey: "margenXTallaSignos",
    yKey: "margenYTallaSignos",
  },
  {
    label: "IMC",
    visibleKey: "mostrarIMC",
    xKey: "margenXIMCSignos",
    yKey: "margenYIMCSignos",
  },
  {
    label: "Clasificación IMC",
    visibleKey: "mostrarClasificacionIMC",
    xKey: "margenXClasificacionIMCSignos",
    yKey: "margenYClasificacionIMCSignos",
  },
];


    export const camposConfigurables = [
        {
          label: "Imagen Principal",
          fieldKey: "mostrarImagen",
          tipo: "imagen", // Nueva categoría para distinguir configuraciones
          marginXKey: "margenXImagen",
          marginYKey: "margenYImagen",
          sizeHorizontalKey: "anchoImagen",
          sizeVerticalKey: "altoImagen",
        },  
        
        {
          label: "Nombre de la Clínica",
          fieldKey: "mostrarNombreClinica",
          tipo: "texto",
          marginXKey: "margenXClinica",
          marginYKey: "margenYClinica",
          sizeKey: "tamañoLetraClinica",
          fontKey: "fuenteClinica",
          colorKey: "colorClinica",
          boldKey: "boldClinica",
        },
        {
          label: "Nombre del Médico (Obligatorio)",
          fieldKey: "mostrarNombre",
          tipo: "texto",
          marginXKey: "margenXNombre",
          marginYKey: "margenYNombre",
          sizeKey: "tamañoLetraNombre",
          fontKey: "fuenteNombre",
          colorKey: "colorNombre",
          boldKey: "boldNombre",
        },
        {
          label: "Escuela (Obligatorio)",
          fieldKey: "mostrarEscuela",
          tipo: "texto",
          marginXKey: "margenXEscuela",
          marginYKey: "margenYEscuela",
          sizeKey: "tamañoLetraEscuela",
          fontKey: "fuenteEscuela",
          colorKey: "colorEscuela",
          boldKey: "boldEscuela",
        },
        /*{
          label: "Comentarios",
          fieldKey: "mostrarComentarios",
          tipo: "texto",
          marginXKey: "margenXComentarios",
          marginYKey: "margenYComentarios",
          sizeKey: "tamañoLetraComentarios",
          fontKey: "fuenteComentarios",
          colorKey: "colorComentarios",
          boldKey: "boldComentarios",
        },*/
        {
          label: "Título Universitario (Obligatorio)",
          fieldKey: "mostrarTituloUniversitario",
          tipo: "texto",
          marginXKey: "margenXTituloUniversitario",
          marginYKey: "margenYTituloUniversitario",
          sizeKey: "tamañoLetraTituloUniversitario",
          fontKey: "fuenteTituloUniversitario",
          colorKey: "colorTituloUniversitario",
          boldKey: "boldTituloUniversitario",
        },
        {
          label: "Cédula Profesional (Obligatorio)",
          fieldKey: "mostrarCedulas",
          labelKey: "mostrarEtiquetaCedulas",
          tipo: "texto",
          marginXKey: "margenXCedulas",
          marginYKey: "margenYCedulas",
          sizeKey: "tamañoLetraCedulas",
          fontKey: "fuenteCedulas",
          colorKey: "colorCedulas",
          boldKey: "boldCedulas",
        },
        {
          label: "Especialidad (Obligatorio)",
          fieldKey: "mostrarEspecialidad",
          tipo: "texto",
          marginXKey: "margenXEspecialidad",
          marginYKey: "margenYEspecialidad",
          sizeKey: "tamañoLetraEspecialidad",
          fontKey: "fuenteEspecialidad",
          colorKey: "colorEspecialidad",
          boldKey: "boldEspecialidad",
        },
        {
          label: "Cédula Especialidad (Obligatorio)",
          fieldKey: "mostrarCedulaEspecialidad",
          labelKey: "mostrarEtiquetaCedulaEspecialidad",
          tipo: "texto",
          marginXKey: "margenXCedulaEspecialidad",
          marginYKey: "margenYCedulaEspecialidad",
          sizeKey: "tamañoLetraCedulaEspecialidad",
          fontKey: "fuenteCedulaEspecialidad",
          colorKey: "colorCedulaEspecialidad",
          boldKey: "boldCedulaEspecialidad",
        },
        {
          label: "Dirección (Obligatorio)",
          fieldKey: "mostrarDireccion",
          tipo: "texto",
          marginXKey: "margenXDireccion",
          marginYKey: "margenYDireccion",
          sizeKey: "tamañoLetraDireccion",
          fontKey: "fuenteDireccion",
          colorKey: "colorDireccion",
          boldKey: "boldDireccion",
        },
        {
          label: "Celular (Obligatorio)",
          fieldKey: "mostrarTelefonoCelular",
          labelKey: "mostrarEtiquetaCelular",
          tipo: "texto",
          marginXKey: "margenXCelular",
          marginYKey: "margenYCelular",
          sizeKey: "tamañoLetraCelular",
          fontKey: "fuenteCelular",
          colorKey: "colorCelular",
          boldKey: "boldCelular",
        },
        {
          label: "Línea Superior",
          fieldKey: "mostrarLineaSuperior",
          tipo: "linea",
          marginXKey: "margenXLineaSuperior",
          marginYKey: "margenYLineaSuperior",
          sizeVerticalKey: "grosorLineaSuperior",
          sizeHorizontalKey: "longitudLineaSuperior",
          colorKey: "colorLineaSuperior",
          
        },
        {
          label: "Marca de Agua",
          fieldKey: "mostrarMarcaAgua",
          tipo: "marcaAgua", // Para identificar que es una marca de agua
          marginXKey: "margenXMarcaAgua",
          marginYKey: "margenYMarcaAgua",
          sizeHorizontalKey: "anchoMarcaAgua",
          sizeVerticalKey: "altoMarcaAgua",
        },
        {
          label: "Fecha (Obligario)",
          fieldKey: "mostrarFecha",
          labelKey: "mostrarEtiquetaFecha",
          tipo: "texto",
          marginXKey: "margenXFecha",
          marginYKey: "margenYFecha",
          sizeKey: "tamañoLetraFecha",
          fontKey: "fuenteFecha",
          colorKey: "colorFecha",
          boldKey: "boldFecha",
        },
        {
          label: "Nombre del Paciente (Obligatorio)",
          fieldKey: "mostrarNombrePaciente",
          labelKey: "mostrarEtiquetaNombrePaciente",
          tipo: "texto",
          marginXKey: "margenXNombrePaciente",
          marginYKey: "margenYNombrePaciente",
          sizeKey: "tamañoLetraNombrePaciente",
          fontKey: "fuenteNombrePaciente",
          colorKey: "colorNombrePaciente",
          boldKey: "boldNombrePaciente",
        },
        {
          label: "Diagnóstico",
          fieldKey: "mostrarDiagnostico",
          labelKey: "mostrarEtiquetaDiagnostico",
          tipo: "texto",
          marginXKey: "margenXDiagnostico",
          marginYKey: "margenYDiagnostico",
          sizeKey: "tamañoLetraDiagnostico",
          fontKey: "fuenteDiagnostico",
          colorKey: "colorDiagnostico",
          boldKey: "boldDiagnostico",
        },
        {
          label: "Tratamiento",
          fieldKey: "mostrarTratamiento",
          labelKey: "mostrarEtiquetaTratamiento",
          tipo: "texto",
          marginXKey: "margenXTratamiento",
          marginYKey: "margenYTratamiento",
          sizeKey: "tamañoLetraTratamiento",
          fontKey: "fuenteTratamiento",
          colorKey: "colorTratamiento",
          boldKey: "boldTratamiento",
        },
    
        {
          label: "Línea Inferior",
          fieldKey: "mostrarLineaInferior",
          tipo: "linea",
          marginXKey: "margenXLineaInferior",
          marginYKey: "margenYLineaInferior",
          sizeVerticalKey: "grosorLineaInferior",
          sizeHorizontalKey: "longitudLineaInferior",
          colorKey: "colorLineaInferior",
          
        },
        
        {
          label: "Firma",
          fieldKey: "mostrarFirma",
          tipo: "texto",
          marginXKey: "margenXFirma",
          marginYKey: "margenYFirma",
          sizeKey: "tamañoLetraFirma",
          fontKey: "fuenteFirma",
          colorKey: "colorFirma",
          boldKey: "boldFirma",
        },
        // === Nuevos campos configurables edad y signos ===
        {
          label: "Edad del Paciente",
          fieldKey: "mostrarEdad",
          labelKey: "mostrarEtiquetaEdad",
          tipo: "texto",
          visibleKey: "mostrarEdad",
          marginXKey: "margenXEdad",
          marginYKey: "margenYEdad",
          sizeKey: "tamañoLetraEdad",
          fontKey: "fuenteEdad",
          colorKey: "colorEdad",
          boldKey: "boldEdad",
        },
        {
          label: "Fecha de nacimiento del Paciente",
          fieldKey: "mostrarFechaNacimiento",
          labelKey: "mostrarEtiquetaFechaNacimiento",
          tipo: "texto",
          visibleKey: "mostrarFechaNacimiento",
          marginXKey: "margenXFechaNacimiento",
          marginYKey: "margenYFechaNacimiento",
          sizeKey: "tamañoLetraFechaNacimiento",
          fontKey: "fuenteFechaNacimiento",
          colorKey: "colorFechaNacimiento",
          boldKey: "boldFechaNacimiento",
        },
        {
          label: "Signos Vitales",
          fieldKey: "mostrarSignos",
          labelKey: "mostrarEtiquetaSignos",
          tipo: "texto",
          visibleKey: "mostrarSignos",
          marginXKey: "margenXSignos",
          marginYKey: "margenYSignos",
          sizeKey: "tamañoLetraSignos",
          fontKey: "fuenteSignos",
          colorKey: "colorSignos",
          boldKey: "boldSignos",
        }

      ];